import React from 'react'
import RouterComponent from '../Router/RouterComponent'

export default function RootComponent(){
    return(
        <RouterComponent/>
    );
}